/**
 * Cakupan persona WMS sisi server (prototype `Sh.invScope` + `ngScope`): dunia RM / Sansugi / FG untuk INV-01 dan dashboard.
 * Salinan FE: `INV_SCOPE_ROLES` / `invScopeOf` di service-library `inventoryReports.constants.ts` (dicek uji paritas).
 */
export const INV_SCOPE_ROLES = {
  fg: ['admin_wh_fg', 'operator_wh_fg', 'supervisor_wh_fg', 'kadiv_wh_fg', 'sales_marketing'],
  sansugi: ['admin_wh_sansugi'],
  ng: ['operator_wh_rm', 'admin_wh_rm', 'wh_rm_supervisor', 'kadiv_wh_rm']
} as const

export type InvScope = { rm: boolean; fg: boolean; ng: boolean; warehouses: string[] }

const hasAny = (codes: readonly string[], list: readonly string[]) => codes.some(code => list.includes(code))

export const invScopeOf = (roleCodes: readonly string[]): InvScope => {
  if (hasAny(roleCodes, INV_SCOPE_ROLES.fg)) return { rm: false, fg: true, ng: false, warehouses: ['WH-FG'] }
  if (hasAny(roleCodes, INV_SCOPE_ROLES.sansugi)) return { rm: true, fg: false, ng: false, warehouses: ['WH-SGI'] }
  return { rm: true, fg: false, ng: hasAny(roleCodes, INV_SCOPE_ROLES.ng), warehouses: ['WH-RM', 'WH-SGI'] }
}
